import React, { useState } from 'react';
import { useResolutionInfo } from '@mm/hooks';
import { isFacebookUserSelector } from '@mm/state/selectors/userSelector';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { QuestionComponent } from './QuestionComponent/QuestionComponent';
import { useCompanyInfoStepBuilder } from './companyInfoStepBuilder';
import './SetCompanyInfo.scss';
import { SignUpFlowMachineService } from '../../../../../../signUpFlowMachine/signUpMachineTypes';
import { StepperComponent } from './Stepper/StepperComponent';
import unicornWay from './unicorn-way.svg';
import { ConnectChannels } from './ConnectChannels/ConnectChannels';
import { companyFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';

type Props = {
  goBack: () => void;
  activeStep: number;
  service: SignUpFlowMachineService;
  isVideoScreenActive?: boolean;
  isConnectChannelsStep?: boolean;
};

export const SetCompanyInfo = (props: Props) => {
  const {
    goBack,
    activeStep,
    service,
    isVideoScreenActive,
    isConnectChannelsStep,
  } = props;
  const { steps } = useCompanyInfoStepBuilder(service);
  const { screenWidth } = useResolutionInfo();
  const SMALL_SCREEN = 600;
  const isFBUser = useSelector(isFacebookUserSelector);
  const isNewSignupFlow = useSelector(
    companyFeatureFlagsSelector,
  ).onboarding2022;

  const [step, setStep] = useState(1);

  const onGoBack = () => {
    setStep(prev => (prev > 0 ? prev - 1 : 1));
    goBack();
  };

  return (
    <div
      className={classNames('set-company-info', {
        'set-company-info-video-screen':
          isVideoScreenActive || isConnectChannelsStep,
      })}
    >
      {activeStep <= (isFBUser ? 6 : 8) && (
        <StepperComponent
          goBack={onGoBack}
          size={isNewSignupFlow ? 3 : isFBUser ? 6 : 8}
          activeStep={isNewSignupFlow ? step : activeStep}
        />
      )}
      {activeStep && !isConnectChannelsStep && (
        <QuestionComponent
          step={steps[activeStep - 1]}
          service={service}
          setStep={setStep}
        />
      )}
      {(isVideoScreenActive || isConnectChannelsStep) && (
        <div
          className={
            isConnectChannelsStep ? 'set-company-info__unicorn-way' : ''
          }
        >
          {isConnectChannelsStep && <ConnectChannels />}
          {screenWidth > SMALL_SCREEN && <img src={unicornWay} />}
        </div>
      )}
    </div>
  );
};
